module.exports = function(ejs) {
var __t, __p = '';
__p += '<div class="ggs-gallery-preview"><div class="ggs-gallery-preview__background" ng-if=":: $ctrl.ggsPost.preview.info.isSomeText"> ' +
((__t = ( ejs.textPreview )) == null ? '' : __t) +
' </div><div class="ggs-gallery-preview__background" ng-if=":: !$ctrl.ggsPost.preview.info.isSomeText"> ' +
((__t = ( ejs.thumbPreview )) == null ? '' : __t) +
' </div></div>';
return __p
}